import {
  CORE_FDE_SKILL_IDS,
  FDE_SKILL_IDS,
  FDE_SKILL_LEVEL_FLOORS,
  type FdeSkillId,
  fdeRequiredDotsAtLevel,
  INFORMATIONAL_FDE_SKILL_IDS,
  impliedFdeLevelFromCoreSkills,
  isFdeLevel,
  isFdeSkillId,
  parseFdeFloorsFromSeed,
  type ResolvedFdeFloors,
} from "../fde-floors";
import type { DisciplineSpec, ResolvedFloors } from "./types";

const FDE_LEVELS = [3, 4, 5, 6] as const;

export const FORWARD_DEPLOYED_SPEC: DisciplineSpec = {
  slug: "forward-deployed",
  name: "Forward Deployed Engineer",
  skillIds: FDE_SKILL_IDS,
  coreSkillIds: CORE_FDE_SKILL_IDS,
  informationalSkillIds: INFORMATIONAL_FDE_SKILL_IDS,
  displayLabels: {
    project_management: "PM",
    stakeholder_management: "SM",
    business_acumen: "Biz",
    hr_fluency: "HR",
    product_sense: "Product",
  },
  levels: FDE_LEVELS,
  floorsConstants: FDE_SKILL_LEVEL_FLOORS as ResolvedFloors,
  impliedLevelFromCoreSkills(scores) {
    return impliedFdeLevelFromCoreSkills({
      project_management: scores.project_management ?? 0,
      stakeholder_management: scores.stakeholder_management ?? 0,
      business_acumen: scores.business_acumen ?? 0,
    });
  },
  requiredDotsAtLevel(skillId, level, floors) {
    if (!isFdeSkillId(skillId)) return 0;
    return fdeRequiredDotsAtLevel(skillId as FdeSkillId, level, floors as ResolvedFdeFloors);
  },
  parseFloorsFromMarkdown(markdown) {
    const parsed = parseFdeFloorsFromSeed(markdown);
    return parsed ? (parsed as ResolvedFloors) : null;
  },
};

// Re-exported here so the FDE-level type guards still have a discipline-aware
// home. Callers should prefer the registry API, but during the migration
// window these stay available so we don't break imports.
export { isFdeLevel, isFdeSkillId };
